module.exports = "/images/Homepage-Interior.jpg";